module.exports = __webpack_public_path__ + "static/img/promoter_tha.8850984c.gif";